import { Injectable } from '@angular/core';
import { WindowScrollerService } from './window-scroller.service';

@Injectable()
export class SimpleScrollerService implements WindowScrollerService {
  scrollIntoView(element: Element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
  }

  scrollIntoViewCenter(element: Element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
  }

  scrollIntoViewOffset(element: Element, yOffset: number) {
    const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
}
